import type { Topic } from "./api";

export type GeneratorCandidate = {
  skillId: string;
  label: string;
  generatorVersion: string;
  designVersion: string;
  subject?: string;
  grade?: number;
  topic?: string;
};

export function generatorCandidates(topics: Topic[]): GeneratorCandidate[] {
  return [...new Map(topics.flatMap((topic) => Object.entries(topic.generator_candidates ?? {})
    .filter(([skillId]) => topic.generator_candidate_designs?.[skillId] || topic.candidate_design_version)
    .map(([skillId, generatorVersion]) => ({
      skillId, generatorVersion, designVersion: topic.generator_candidate_designs?.[skillId] ?? topic.candidate_design_version!,
      subject: topic.subject_id,
      grade: Number(skillId.match(/\.g(\d+)\./)?.[1]),
      topic: topic.group_label || topic.label,
      label: topic.generator_candidate_labels?.[skillId] ?? topic.label,
    }))).map(candidate=>[candidate.skillId,candidate])).values()];
}

export function candidateSelectors(skillId: string, candidates: GeneratorCandidate[]) {
  const candidate = candidates.find((item) => item.skillId === skillId);
  return candidate ? {
    generator_version: candidate.generatorVersion,
    design_version: candidate.designVersion,
  } : {};
}
